export default __webpack_public_path__ + "static/media/imagePlaceholder.aa93aa9d.svg";